import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import { articles, faqs, siteInfo } from "@/mocks/news";
import HeroSection from "./components/HeroSection";
import SpotlightSection from "./components/SpotlightSection";
import LatestSection from "./components/LatestSection";
import CategorySection from "./components/CategorySection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";

export default function Home() {
  const ranked = [...articles].sort((a, b) => a.rank - b.rank).slice(0, 8);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: siteInfo.domain,
      description: siteInfo.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${siteInfo.domain}/?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: siteInfo.domain,
      description: siteInfo.description,
      email: siteInfo.contactEmail,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "看瓜爆料实时热榜",
      itemListElement: ranked.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${siteInfo.domain}/article/${item.id}`,
        name: item.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="看瓜爆料 | 今日速递 实时更新 新鲜瓜料随时刷"
        description="看瓜爆料最新实时更新，今日热点瓜料、新鲜爆料速递不停歇。点开即看当下最热事件进展，随时刷新随时有料，满足你第一时间追瓜、吃瓜、看内幕的需求。"
        keywords="看瓜爆料,看瓜爆料最新,看瓜爆料今日,看瓜爆料实时,看瓜爆料速递"
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <SpotlightSection />
        <LatestSection />
        <CategorySection />
        <FaqSection />
        <BrandSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}